"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostAvatarRequest = void 0;
var file_1 = require("../../../library/file");
var PostAvatarRequest = /** @class */ (function () {
    function PostAvatarRequest() {
        this.file = new file_1.File();
    }
    return PostAvatarRequest;
}());
exports.PostAvatarRequest = PostAvatarRequest;
;
//# sourceMappingURL=postAvatar.request.js.map